import { type VariantProps, cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";
import { VenueId } from "../venue-logo-list/venue-logo-list";

export interface LogoProps extends VariantProps<typeof LogoStyles> {
    venueId: VenueId;
    isInternalLink?: boolean;
    href?: string | undefined;
    className?: string;
}

export const LogoStyles = cva("focus", {
    variants: {
        size: {
            xs: "w-8",
            sm: "w-12",
            md: "w-auto",
        },
        color: {
            white: "fill-white",
        },
    },
    defaultVariants: {
        size: "md",
    },
});

export const Logo = ({
    size,
    color,
    href,
    className,
    venueId,
    ...props
}: LogoProps): JSX.Element => {
    const { t } = useTranslation();
    const alt = t(`venues.${venueId}.name`);
    const src = `/assets/${venueId}/logo.svg`;

    const image = (): JSX.Element => (
        <img
            alt={alt}
            className={twMerge(LogoStyles({ className, size, color }))}
            src={src}
            {...props}
        />
    );

    if (href) {
        return (
            <a
                className="focus z-10 inline-block h-fit px-2 pb-2"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {image()}
                <span className="sr-only">
                    {t("goToWebsite", {
                        brand: t(`venues.${venueId}.name`),
                    })}
                </span>
            </a>
        );
    }

    return image();
};
